<template>
    <div id="tooltip__tooltip">
        <ul class="tooltip" id="tooltip__tooltip--list">
            <li 
            v-ripple="{ class: `primary--text` }"
            v-for="(s, i) in senders"
            v-bind:key="i"
            @click="sendEvent(s)"
            >{{s}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'SenderListTooltip',
    props: [
        'senders',
    ],
    methods: {
        sendEvent: function(s) {
            this.$emit('chooseSender', s)
        }
    },
}
</script>

<style lang="sass" scoped>
@import "./../assets/sass/_common.sass"
</style>
